import { createContext, useReducer, useEffect } from "react";
import { projectAuth, projectFirestore } from "../../firebase-config/config";
export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { ...state, user: action.payload };
    case "LOGOUT":
      return { ...state, user: null };
    case "AUTH_IS_READY":
      return { user: action.payload, authIsReady: true };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
    authIsReady: false,
  });

  // let role = [];
  // let online;
  // let displayName;
  // let fullName;
  // let phoneNumber;
  // let city;
  // let address;
  // let photoURL;
  // let status;
  // let createdAt;
  // let lastLoginTimestamp;

  // useEffect(() => {
  //   const unsub = projectAuth.onAuthStateChanged(user => {
  //     dispatch({ type: 'AUTH_IS_READY', payload: user })
  //     unsub();
  //   })
  // }, [])

  // let userData = {};

  useEffect(() => {
    const unsub = projectAuth.onAuthStateChanged((user) => {
      // console.log('AuthContext state in useEffect:', state)
      // update online status
      if (user) {
        const phoneNumber = user.phoneNumber;
        const PhoneWithoutPlus = phoneNumber.slice(1);

        const documentRef = projectFirestore
          .collection("users")
          .doc(PhoneWithoutPlus);
        const unsubscribe = documentRef.onSnapshot((snapshot) => {
          // need to make sure the doc exists & has data
          if (snapshot.data()) {
            let role = snapshot.data().role;
            let roles = snapshot.data().roles;
            let online = snapshot.data().online;
            let displayName = snapshot.data().displayName;
            let fullName = snapshot.data().fullName;
            let phoneNumber = snapshot.data().phoneNumber;
            let email = snapshot.data().email;
            let city = snapshot.data().city;
            let country = snapshot.data().country;
            let countryCode = snapshot.data().countryCode;
            let address = snapshot.data().address;
            let photoURL = snapshot.data().photoURL;
            let status = snapshot.data().status;
            let createdAt = snapshot.data().createdAt;
            let lastLoginTimestamp = snapshot.data().lastLoginTimestamp;
            let addresses = snapshot.data().addresses;
            let isAttendance = snapshot.data().isAttendance;
            let vehicleNumberPlate = snapshot.data().vehicleNumberPlate;
            let vehicleStatus = snapshot.data().vehicleStatus;
            let vehicleType = snapshot.data().vehicleType;
            let isStaff = snapshot.data().isStaff;
            let drivingLicence = snapshot.data().drivingLicence;
            let gender = snapshot.data().gender;
            let accessValue = snapshot.data().accessValue;
            let accessType = snapshot.data().accessType;
            let faceRegistration = snapshot.data().faceRegistration;
            let registeredFaceUrl = snapshot.data().registeredFaceUrl;
            let organisationId = snapshot.data().organisationId;

            let id = snapshot.data().id;
            console.log("User Snapshot Data: ", snapshot.data());

            let userData = {
              ...user,
              id,
              role,
              roles,
              online,
              displayName,
              fullName,
              gender,
              phoneNumber,
              email,
              city,
              country,
              countryCode,
              address,
              addresses,
              photoURL,
              status,
              isAttendance,
              vehicleNumberPlate,
              vehicleStatus,
              vehicleType,
              isStaff,
              drivingLicence,
              accessType,
              accessValue,
              faceRegistration,
              registeredFaceUrl,
              createdAt,
              lastLoginTimestamp,
              organisationId,
            };
            console.log("User Data:", userData);

            dispatch({ type: "AUTH_IS_READY", payload: userData });
          }
        });
        return () => {
          unsubscribe();
        };
      } else {
        dispatch({ type: "AUTH_IS_READY", payload: user });
      }
      // dispatch({ type: 'AUTH_IS_READY', payload: userData })
      // unsub()
    });

    return () => {
      unsub();
    };
  }, []);

  // console.log('AuthContext state:', state)

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
